import { HttpContextToken } from '@angular/common/http';

/**
 * Set to `true` on requests that handle `InsufficientPermissions` themselves (e.g. a user action
 * like a file upload). Prevents `ApartmentIdApiInterceptor` from navigating the user out of the
 * current apartment; the caller is expected to show a notification instead.
 */
export const SKIP_INSUFFICIENT_PERMISSIONS_REDIRECT = new HttpContextToken<boolean>(() => false);
